

module.exports = angular.module('msi.modals', [
  'ui.bootstrap',
  require('./confirmation-dialog'),
  require('./close'),
  require('./header')
]).name;

angular.module(module.exports)
  .config(require('./config'));
